import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/useFocusRing-dee26278.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../3rdPartyModules/_react-aria/utils/dist/mergeProps-29aac069.js';
import { f as focusOutlineMixin } from '../../FocusIndicator/styleMixins/focusOutline-ae6f4c7f.js';
import { k as keys } from '../../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-04a50e15-b033061a.js';
import { T as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-f853b17a.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-39f30e88.js';

// eslint-disable-next-line max-len

const NavItem = /*#__PURE__*/styled('li').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible,
    type: 'button'
  };
}).withConfig({
  componentId: "sc-storm-ui-30051113__sc-1naj74z-0"
})(["font-weight:", ";color:", ";border-left:", ";box-sizing:border-box;width:100%;padding-right:", ";padding-top:", ";padding-bottom:", ";padding-left:", ";margin:", ";display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:center;align-items:center;cursor:pointer;font-size:", ";:active,:visited{color:", ";}:link{color:", ";text-decoration:none;}:hover{font-weight:bold;}:focus{outline:none;", "}"], ({
  $isActive,
  theme
}) => $isActive ? theme.sideNavItem.activeFontWeight : theme.sideNavItem.inactiveFontWeight, ({
  theme
}) => theme.sideNavItem.color, ({
  $isActive,
  theme
}) => $isActive ? theme.sideNavItem.activeBorderLeft : theme.sideNavItem.inactiveBorderLeft, ({
  theme
}) => theme.sideNavItem.paddingRight, ({
  theme
}) => theme.sideNavItem.paddingTop, ({
  theme
}) => theme.sideNavItem.paddingBottom, ({
  $isActive,
  $subItem,
  theme
}) => {
  if ($subItem) {
    if ($isActive) {
      return theme.sideNavItem.subItemActiveLeftPadding;
    }
    return theme.sideNavItem.subItemInactiveLeftPadding;
  }
  if ($isActive) {
    return theme.sideNavItem.activeLeftPadding;
  }
  return theme.sideNavItem.inactiveLeftPadding;
}, ({
  theme,
  $subItem
}) => $subItem ? theme.sideNavItem.marginSubItem : theme.sideNavItem.margin, ({
  $subItem
}) => $subItem ? '12px' : '13px', ({
  theme
}) => theme.sideNavItem.color, ({
  theme
}) => theme.sideNavItem.color, ({
  focusVisible
}) => focusVisible && focusOutlineMixin);
NavItem.displayName = 'NavItem';
const NavItemLabel = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-30051113__sc-1naj74z-1"
})(["flex:0 1 auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
NavItemLabel.displayName = 'NavItemLabel';
class SideNavItem extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleKeyDown", event => {
      const {
        key
      } = event;
      const {
        onClick
      } = this.props;
      if (key === keys.ENTER || key === keys.SPACE) {
        onClick === null || onClick === void 0 || onClick(event);
        event.preventDefault();
      }
    });
  }
  render() {
    const {
      onClick,
      isActive,
      subItem,
      children,
      renderStart,
      renderEnd,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('side-nav-item')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(NavItem, _extends({}, getDataTaktAttributes(), rest, {
      onClick: onClick,
      $isActive: isActive,
      $subItem: subItem,
      tabIndex: 0,
      role: "button",
      onKeyDown: this.handleKeyDown
    }), renderStart && renderStart(), /*#__PURE__*/React__default.createElement(NavItemLabel, null, children), renderEnd && renderEnd()));
  }
}
_defineProperty(SideNavItem, "propTypes", {
  /**
   * onClick function passed to SideNavItem.
   */
  onClick: PT.func,
  /**
   * Determines if the item is active or not.
   */
  isActive: PT.bool,
  /**
   * Determines if the item is a subItem or not (displays indented).
   */
  subItem: PT.bool,
  /**
   * What to display in the side nav item.
   */
  children: PT.node.isRequired,
  /**
   * Render a component before the item's label.
   */
  renderStart: PT.func,
  /**
   * Render a component after the item's label.
   */
  renderEnd: PT.func
});
_defineProperty(SideNavItem, "defaultProps", {
  onClick: undefined,
  subItem: false,
  isActive: false,
  renderStart: undefined,
  renderEnd: undefined
});
var SideNavItem$1 = SideNavItem;

export { SideNavItem$1 as S };
//# sourceMappingURL=SideNavItem-e0105db2.js.map
